import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let SchoolService = {};

((SchoolService) =>
{
  SchoolService.getSchools = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/schools"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SchoolService.onServiceComplete);
  };

  SchoolService.getSchoolsForZip = function(zip)
  {
    return request.get({
      url:  utils.getServiceUrl("/schools/zip/" + zip),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SchoolService.onServiceComplete);
  };

  SchoolService.requestToAddSchool = function(schoolNumber, schoolName, schoolAddress)
  {
    return request.post({
      url:  utils.getServiceUrl("/schools/request_to_add"),
      cache: false,
      data:
        {
          "school-number" : schoolNumber,
          "school-name" : schoolName,
          "school-address" : schoolAddress
        }
    })
      .then(SchoolService.onServiceComplete);
  };

  SchoolService.linkUser = function(schoolKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/schools/" + schoolKey + "/link"),
      cache: false,
      dataType: request.DATA_TYPES.JSON
    })
      .then(SchoolService.onServiceComplete);
  };

  SchoolService.unlinkUser = function(schoolKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/schools/" + schoolKey + "/unlink"),
      cache: false,
      dataType: request.DATA_TYPES.JSON
    })
      .then(SchoolService.onServiceComplete);
  };

  SchoolService.onServiceComplete = function (data)
  {
    if(utils.isNotNull(data) && data.result === "success" && data.data)
    {
      return data.data;
    }

    return null;
  }

})(SchoolService);

module.exports = SchoolService;



// WEBPACK FOOTER //
// ./app/js/services/school-service.js